import {BaseComponent} from "../base/base.component";

export abstract class ShopBaseComponent extends BaseComponent {

    getCartQuantity() {
        let products = localStorage.getItem('wisper_products');
        let parsedProducts = products ? JSON.parse(products) : [];
        return parsedProducts.reduce((acc: any, product: any) => acc + product.quantity, 0);
    }

    addProductLocalStorage(product: any) {
        let products = JSON.parse(localStorage.getItem('wisper_products') || '[]');

        const existingProductIndex = products.findIndex((existingProduct: any) =>
            existingProduct.barcode === product[0].barcode
        );

        if (existingProductIndex !== -1) {
            console.log('existingProductIndex', JSON.stringify(product) + ' ' + JSON.stringify(products[existingProductIndex]))
            products[existingProductIndex].quantity += product[0].quantity;
        } else {

            products = [...products, ...product];
        }

        localStorage.setItem('wisper_products', JSON.stringify(products));
    }

    removeProductLocalStorage(product: any){
        let products: any = localStorage.getItem('wisper_products') ?? [];
        products = JSON.parse(products)

        products = products.filter((item: any) => item.barcode !== product.barcode);

        if (products.length === 0) {
            localStorage.removeItem('wisper_products');
        } else {
            localStorage.setItem('wisper_products', JSON.stringify(products));
        }
    }

    getProductsLocalStorage(){
        let products = localStorage.getItem('wisper_products');
        return products ? JSON.parse(products) : [];
    }

    cartSubTotal(products: any) {
        return products.reduce((acc: any, product: any) => acc + product.price * product.quantity, 0);
    }

    getUserId() {
        return localStorage.getItem('wisper_userId')
    }

    getVatPrice(price: number) {
        return price * (0.22);
    }

}
